import React, { useEffect, useState } from 'react'
import Style from './TaxiReqCondition.module.css'
import BottomNavigation from '../../Components/BottomNavigation/BottomNavigation'
import { TaxiCurrentAPI, TaxiFinishedTravelApi, liveLocationPostApi } from '../../Api/DeliveryBarest'
import { errorToast } from './../../Utils/Toast/Toast';
import TaxiCurrentTraverlDetail from '../../Components/TaxiCurrentTraverlDetail/TaxiCurrentTraverlDetail';
import TaxiFinishTravel from '../../Components/TaxiFinishTravel/TaxiFinishTravel';
const TaxiReqCondition = () => {
    const[checkTable,setCheckTable]=useState(true)
    const[TraverDetailState,setTraverDetailState]=useState(null)
    const[finishedTraverDetailState,setFinishedTraverDetailState]=useState(null)
    const MINUTE_MS=6000
    useEffect(()=>{
      getCurrentTravel()
      getFinishedTravel()
      const interval = setInterval(() => {
        getLocation()
      }, MINUTE_MS);
      return () => clearInterval(interval)
    },[])
    
    var x = document.getElementById("demo");
    function getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else { 
        x.innerHTML = "Geolocation is not supported by this browser.";
      }
    }
    
    function showPosition(position) {
      LiveLocationPost(position)
    }
  
    const LiveLocationPost=(position)=>{
      let info = {
        lat:position.coords.latitude,
        lon:position.coords.longitude
      }
      liveLocationPostApi(info,res=>{
      })
    }

    const getCurrentTravel=()=>{
      TaxiCurrentAPI((res)=>{
        if(res.status===1){
          setTraverDetailState(res.travels[0])
        }else{
          errorToast(res.message)
        }
      })
    }
    const getFinishedTravel=()=>{
      TaxiFinishedTravelApi((res)=>{
        if(res.status===1){
          setFinishedTraverDetailState(res.travels)
        }else{
          errorToast(res.message)
        }
      })
    }
  return (
    <div className={Style.PageHolder}>
    <section className={Style.tabHolder}>
        <div className={checkTable?Style.onFocus:Style.cursor} onClick={()=>setCheckTable(true)}>  سفر های قبول شده</div>
        <div className={checkTable?Style.cursor:Style.onFocus} onClick={()=>setCheckTable(false)}> سفرهای قبلی</div>
    </section>
    {
        checkTable?<TaxiCurrentTraverlDetail detail={TraverDetailState} updateReq={getCurrentTravel}/>:<TaxiFinishTravel finishedTraverDetailState={finishedTraverDetailState}/>
    }
    <BottomNavigation/>
</div>
  )
}

export default TaxiReqCondition